import React from "react";
import { connect } from "react-redux";
import { Field, reduxForm } from "redux-form";
import { createTextMask } from "redux-form-input-masks";
import uuid from "uuidv4";

import klerData from "../../apis/klerData";

const phoneMask = createTextMask({
  pattern: "(999) 999-9999",
  stripMask: false,
  guide: true
});

class LocationEdit extends React.Component {
  render() {
    const updateRecord = formValues => {
      let updatedata = "";
      updatedata += "{";
      if (formValues.Business) {
        updatedata += 'Business: "' + formValues.Business + '",';
      }
      if (formValues.FirstName) {
        updatedata += 'FirstName: "' + formValues.FirstName + '",';
      }
      if (formValues.Email) {
        updatedata += 'Email: "' + formValues.Email + '",';
      }
      if (formValues.Phone) {
        updatedata += 'Phone: "' + formValues.Phone + '",';
      }
      updatedata += 'Oid: "' + formValues.Oid + '"';
      updatedata += "}";

      if (formValues.Oid) {
        // **************************
        // UPDATE RECORD
        klerData
          .put(`/Subscription(${parseInt(formValues.Oid)})`, updatedata)
          .then(result => {
            this.props.handleCloseReload();
          })
          .catch(error => console.log(error));
      } else {
        // **************************
        // CREATE SUBSCRIPTION
        const newId = uuid();
        console.log("NEED TO CREATE SUBSCRIPTION");

        // CREATE SUBSCRIPTION
        let createSubscription = "";
        createSubscription += "{";
        if (formValues.Business) {
          createSubscription += 'Business: "' + formValues.Business + '",';
        }
        if (formValues.FirstName) {
          createSubscription += 'FirstName: "' + formValues.FirstName + '",';
        }
        if (formValues.Email) {
          createSubscription += 'Email: "' + formValues.Email + '",';
        }
        if (formValues.Phone) {
          createSubscription += 'Phone: "' + formValues.Phone + '",';
        }
        createSubscription += 'SubscriptionId: "' + newId + '"';
        createSubscription += "}";
        console.log("SUBSCRIPTION");
        console.log(createSubscription);
        klerData
          .post(`/Subscription`, createSubscription)
          .then(result => {
            console.log("SUBSCRIPTION CREATED");
          })
          .catch(error => console.log(error));

        // SELECT SUBSCRIPTION ID
        klerData
          .get(
            `/Subscription?$filter=SubscriptionId eq '${newId}'&select=Oid&$format=json`
          )
          .then(result => {
            createUser(result.data.d[0]);
          })
          .catch(error => console.log(error));

        const createUser = data => {
          // CREATE USER ACCOUNT
          let createUserAccess = "";
          createUserAccess += "{";
          createUserAccess +=
            'SubscriptionId@odata.bind: "Subscription(' + data.Oid + ')",';
          createUserAccess += 'Email: "' + formValues.UserId + '",';
          createUserAccess += "Admin: true";
          createUserAccess += "}";
          console.log("USER ACCOUNT");
          console.log(createUserAccess);
          klerData
            .post(`/UserAccess`, createUserAccess)
            .then(result => {
              console.log("ACCOUNT CREATED");
              this.props.handleCloseReload();
            })
            .catch(error => console.log(error));
        };
      }
    };
    const onSubmit = formValues => {
      // console.log(formValues);
      updateRecord(formValues);
    };
    return (
      <div className="txt-center">
        <h4>Business</h4>
        <form onSubmit={this.props.handleSubmit(onSubmit)}>
          <div>
            <Field
              name="Oid"
              component="input"
              type="hidden"
              autoComplete="off"
            />
            <Field
              name="SubscriptionId"
              component="input"
              type="hidden"
              autoComplete="off"
            />
            <Field
              name="UserId"
              component="input"
              type="hidden"
              autoComplete="off"
            />
          </div>
          <div>
            <label>Business Name</label>
            <div>
              <Field
                name="Business"
                component="input"
                type="text"
                placeholder="Business Name"
                autoComplete="off"
              />
            </div>
          </div>
          <div>
            <label>Billing Contact</label>
            <div>
              <Field
                name="FirstName"
                component="input"
                type="text"
                placeholder="Billing Contact"
                autoComplete="off"
              />
            </div>
          </div>
          <div>
            <label>Billing Email</label>
            <div>
              <Field
                name="Email"
                component="input"
                type="text"
                placeholder="Billing Email"
                autoComplete="off"
              />
            </div>
          </div>
          <div>
            <label>Billing Phone</label>
            <div>
              <Field
                name="Phone"
                component="input"
                type="text"
                placeholder="Billing Phone"
                autoComplete="off"
                {...phoneMask}
              />
            </div>
          </div>
          <button className="waves-effect waves-light btn btn-small">
            Submit
          </button>
          &nbsp;
          <button
            type="button"
            className="waves-effect waves-light btn btn-small"
            onClick={this.props.handleClose}
          >
            Cancel
          </button>
        </form>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  if (ownProps.data) {
    return {
      initialValues: {
        SubscriptionId: ownProps.data.SubscriptionId.SubscriptionId,
        Oid: ownProps.data.SubscriptionId.Oid,
        Business: ownProps.data.SubscriptionId.Business,
        FirstName: ownProps.data.SubscriptionId.FirstName,
        Email: ownProps.data.SubscriptionId.Email,
        Phone: ownProps.data.SubscriptionId.Phone,
        UserId: ownProps.userId
      }
    };
  } else {
    return {
      initialValues: {
        SubscriptionId: ownProps.subscriptionId,
        Oid: "",
        Business: "",
        FirstName: "",
        Email: "",
        Phone: "",
        UserId: ownProps.userId
      }
    };
  }
};

const validate = formValues => {
  const errors = {};

  if (!formValues.Business) {
    errors.Business = "Please enter a business name";
  }

  return errors;
};

export default connect(mapStateToProps)(
  reduxForm({
    form: "LocationForm",
    validate
  })(LocationEdit)
);
